
/*** This barrel file provides the exports for the shared resources (services, components). */

/* shared components exports */

export * from './header/index';
export * from './footer/index';
export * from './breadcrumb/index';
export * from './navigation/index';
export * from './modeldialog/model-dialog.module';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/sharedindex.ts